import React, { useState } from 'react';
import { Box, Container, useDisclosure } from '@chakra-ui/react';
import LogsTable from './components/LogsTable';

function Logs() {
    const [selectedOrder, setSelectedOrder] = useState(null);
    const { isOpen, onOpen, onClose } = useDisclosure();

    const handleOrderClick = (order) => {
        setSelectedOrder(order);
        onOpen();
    };

    return (
       <Container maxW="xxl" mt={100} p={{ base: 4, md: 8 }} >
            <LogsTable />
        </Container>
    );
}

export default Logs;
